import { ChartContainer, ChartTooltip, ChartTooltipContent } from '@/components/ui/chart';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@careflux/primitives';
import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from 'recharts';
import type { HorizontalBarChartProps } from './components.types';
import { chartFrameClasses, emptyStateClasses } from './summaryQuality.styles';

const truncate = (value: string, max = 24) => (value.length > max ? `${value.slice(0, max - 1)}…` : value);

export const HorizontalBarChart = ({ title, description, data, valueLabel, formatValue }: HorizontalBarChartProps) => (
  <Card padding="lg">
    <CardHeader>
      <CardTitle>{title}</CardTitle>
      <CardDescription>{description}</CardDescription>
    </CardHeader>
    <CardContent>
      {data.length === 0 ? (
        <div className={emptyStateClasses}>Engin gögn fyrir valið tímabil.</div>
      ) : (
        <ChartContainer
          config={{ value: { label: valueLabel, color: 'hsl(var(--chart-1))' } }}
          className={chartFrameClasses}
        >
          <BarChart data={data} layout="vertical" margin={{ left: 8, right: 16 }} barCategoryGap={2}>
            <CartesianGrid horizontal={false} />
            <XAxis
              type="number"
              tickLine={false}
              axisLine={false}
              tickMargin={8}
              tickFormatter={(value) => formatValue(Number(value))}
            />
            <YAxis
              dataKey="label"
              type="category"
              tickLine={false}
              axisLine={false}
              tickMargin={8}
              width={160}
              tickFormatter={(value) => truncate(String(value))}
            />
            <ChartTooltip content={<ChartTooltipContent valueFormatter={(value) => formatValue(Number(value))} />} />
            <Bar dataKey="value" fill="var(--color-value)" radius={[0, 4, 4, 0]} maxBarSize={24} />
          </BarChart>
        </ChartContainer>
      )}
    </CardContent>
  </Card>
);
